<template>
    <div class="px-3 px-sm-5 py-4">
        <div class="panel mb-0">
            <div class="panel-hdr">
                <h2>{{$t('button_link.add') + $t(`subMenu.salon_menu_reward`)}}</h2>
            </div>
            <div class="panel-container">
                <div class="panel-content">
                    <rewardForm :isEdit="false" @returnRewardList="returnRewardList"></rewardForm>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RewardForm from './Reward_Form'
export default {
    name: "addReward",
    components:{
        RewardForm
    },
    methods:{
        returnRewardList(selectedOutlet){
            this.$emit('returnRewardList', selectedOutlet)
        },
    }
}
</script>